import { useLocation } from 'react-router-dom';

// eslint-disable-next-line import/prefer-default-export
export const useQueryUrl = () => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};
